import {omit} from 'lodash'
import {useEffect} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {useParams} from 'react-router'
import {useHistory} from 'react-router-dom'

import {useTranslation} from '../../../../hooks/useTranslation'

import {OrderManagementConfigurationDetails} from './components/OrderManagementConfigurationDetails'
import {useOrderChangeConfigsCreateMutation} from './hooks/useOrderChangeConfigsMutations'
import {useOrderChangeConfigsQuery} from './hooks/useOrderChangeConfigsQuery'
import {useOrderChangeConfigFieldsQuery} from './hooks/useOrderChangeConfigurationOptions'
import {OrderChangeCreateConfig} from './types/OrderChangeConfig'

export const OrderChangeConfigurationCopy = () => {
  const {configId} = useParams<{
    configId?: string
  }>()

  const {t} = useTranslation()
  const history = useHistory()
  const orderChangeConfigsMutation = useOrderChangeConfigsCreateMutation()

  const orderChangeConfigQueryInfo = useOrderChangeConfigsQuery()
  const orderChangeConfigFieldsQueryInfo = useOrderChangeConfigFieldsQuery()

  const methods = useForm<OrderChangeCreateConfig>({
    defaultValues: {} as OrderChangeCreateConfig,
    mode: 'onChange'
  })

  useEffect(() => {
    if (configId && orderChangeConfigQueryInfo.data) {
      const config = orderChangeConfigQueryInfo.data.find((config) => config.id === configId)
      if (config) {
        const configWithoutId = omit(config, 'id')
        const fieldSettingsWithoutIds = configWithoutId.changeableFields.map((field) => {
          const fieldWithoutIds = omit(field, ['id', 'orderChangeSettingId'])
          return {
            ...fieldWithoutIds,
            editLeadTime: Number(field.editLeadTime)
          }
        })

        methods.reset({
          ...configWithoutId,
          changeableFields: fieldSettingsWithoutIds
        } as OrderChangeCreateConfig)
      }
    }
  }, [configId, orderChangeConfigQueryInfo.data, methods])

  const handleCopyButtonClick = async (data: OrderChangeCreateConfig) => {
    try {
      await orderChangeConfigsMutation.mutateAsync(data)
    } finally {
      history.goBack()
    }
  }

  if (orderChangeConfigFieldsQueryInfo.isLoading || !orderChangeConfigFieldsQueryInfo.data) {
    return <div>{t('configurations.hconnect.orderManagement.configurationDetails.loading')}</div>
  }

  return (
    <FormProvider {...methods}>
      <OrderManagementConfigurationDetails
        mode="copy"
        configId={configId}
        onSaveButtonClick={methods.handleSubmit(handleCopyButtonClick)}
        configOptions={orderChangeConfigFieldsQueryInfo.data}
        isSubmitting={orderChangeConfigsMutation.isLoading}
      />
    </FormProvider>
  )
}
